import { useEffect, useState } from "react";
import { AiSentimentLiveEvent } from "@/model/interface/AiAgent";
import { useSocketSubscription } from "@/hooks/useSocketSubscription";

export function useAiSentimentSocket(callSid: string | null) {
  const [latestSentiment, setLatestSentiment] = useState<AiSentimentLiveEvent | null>(null);

  useEffect(() => {
    setLatestSentiment(null);
  }, [callSid]);

  useSocketSubscription(callSid ? `/topic/ai-sentiment/${callSid}` : null, (message) => {
    try {
      setLatestSentiment(JSON.parse(message.body) as AiSentimentLiveEvent);
    } catch (parseError) {
      console.error("Failed to parse AI sentiment event", parseError);
    }
  });

  return { latestSentiment };
}
